import { axios } from '../internal';
import { CollectionType, PreferenceType } from './types';

const URI = '/preferences/preferences';
const CURRENT_USER = '@currentUser';

export type PreferenceItem = { id: string; value: string; application?: string };

export const setPreferences = async (
  data: Array<PreferenceItem>,
  options: Record<string, unknown> = {}
): Promise<CollectionType<PreferenceType>> => {
  const config = Object.assign(options, {
    headers: {
      Accept: 'application/vnd.sas.collection+json',
      contentType: 'application/vnd.sas.collection+json',
    },
  });

  const url = `${URI}/${CURRENT_USER}`;
  const response = await axios.put(url, data, config);

  return response.data;
};

export const getPreferences = async (
  options: Record<string, unknown> = {}
): Promise<CollectionType<PreferenceType>> => {
  const config = Object.assign(options, {
    headers: {
      Accept: 'application/vnd.sas.collection+json',
    },
  });

  const url = `${URI}/${CURRENT_USER}`;
  const response = await axios.get(url, config);

  return response.data;
};

export const getPreference = async (
  id: string,
  options: Record<string, unknown> = {}
): Promise<PreferenceType> => {
  const config = Object.assign(options, {
    headers: {
      Accept: 'application/vnd.sas.preference+json',
    },
  });

  const url = `${URI}/${CURRENT_USER}/${id}`;
  const response = await axios.get(url, config);

  return response.data;
};

export const deletePreferences = async (
  keys: Array<string>,
  options: Record<string, unknown> = {}
): Promise<void> => {
  const data = keys.map((key) => ({
    id: key,
  }));

  const config = Object.assign(options, {
    data: { items: data },
    headers: {
      Accept: 'application/vnd.sas.collection+json',
      contentType: 'application/vnd.sas.collection+json',
    },
  });

  const url = `${URI}/${CURRENT_USER}`;

  return axios.delete(url, config);
};
